var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbrFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_filter",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.93 72V45.3c0-1.8-.8-3.5-2.2-4.6l-18.1-14.8c-2.4-1.9-3.7-4.7-3.7-7.7V8h64v10.2c0 3-1.3 5.8-3.7 7.7l-18.1 14.7c-1.4 1.1-2.2 2.8-2.2 4.6V63l-16 9zm-20-60v6.2c0 1.8.8 3.5 2.2 4.6l18.1 14.8c2.3 1.9 3.7 4.7 3.7 7.7v19.9l8-4.5V45.3c0-3 1.3-5.8 3.7-7.7l18.1-14.8c1.4-1.1 2.2-2.8 2.2-4.6V12h-56z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrFilter);
export default __webpack_public_path__ + "static/media/ubr_filter.d0777fa86432903749f88497de85835c.svg";
export { ForwardRef as ReactComponent };